export default {"src":"/_next/static/media/waivedoff.75fb239a.svg","height":28,"width":114,"blurWidth":0,"blurHeight":0};